import { createContext } from 'react'

// Initialize Context as an empty object,
// Each key in the object will correspond to a common function
const FunctionContext = createContext({})

export default FunctionContext
